import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class PlatformApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    listConnectionSuggestions() {
        return axios.get(`${URL_API}/plataforma/sugestoes-conexao`, this.getConfig())
    }

    listConnectionSuggestionsPage(page) {
        return axios.get(`${URL_API}/plataforma/sugestoes-conexao?page=${page}`, this.getConfig())
    }

    filterConnectionSuggestions(data) {
        return axios.post(`${URL_API}/plataforma/sugestoes-conexao`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    sendInvite(data) {
        return axios.post(`${URL_API}/redes-parceiros/invite-ppp`, { ...data }, this.getConfig())
    }

    makeRegister(data) {
        return axios.post(`${URL_API}/cadastro/usuario`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    getRegistrationPermissions() {
        return axios.get(`${URL_API}/cadastro/permission`, this.getConfig())
    }

    getAllProfileData(userId) {
        return axios.get(`${URL_API}/plataforma/perfil-organizacao/${userId}`, this.getConfig())
    }

    getMyConnections(userId) {
        return axios.get(`${URL_API}/plataforma/minhas-conexoes`, this.getConfig())
    }

    answerConnection(data) {
        return axios.post(`${URL_API}/plataforma/responder-conexao`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    setUndoConnection(data) {
        return axios.post(`${URL_API}/plataforma/desfazer-conexao`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    setRequestConnection(data) {
        return axios.post(`${URL_API}/plataforma/solicitar-conexao`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    setEvaluation(data) {
        return axios.post(`${URL_API}/plataforma/avaliacao`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    answerEvaluation(data) {
        return axios.post(`${URL_API}/plataforma/avaliacao`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/platform/PlatformApi.js